export default [
    {
        path: '/webview/scan-voucher',
        name: 'voucher-scan-webview',
        meta: {
            disableDashboardLayout: true
        },
        component: () => import('~/views/webviews/VoucherScanDialog.vue')
    },
    {
        path: '/webview/scan-voucher/:id',
        name: 'voucher-scan-webview-id',
        meta: {
            disableDashboardLayout: true
        },
        component: () => import('~/views/webviews/VoucherScanDialog.vue')
    },
    {
        path: '/webview/periodic-registration',
        name: 'periodic-registration-webview',
        meta: {
            disableDashboardLayout: true
        },
        component: () => import('~/views/webviews/PeriodicRegistrationDialog.vue')
    },
    {
        path: '/webview/book',
        name: 'book-webview',
        meta: {
            disableDashboardLayout: true
        },
        component: () => import('~/views/webviews/BookingsDialog.vue')
    },
    {
        path: '/webview/odeon',
        name: 'webbiew-odeon',
        meta: {
            disableDashboardLayout: true
        },
        component: () => import('~/views/webviews/OdeonPopup.vue')
    }
]
